import type {
  FormattedResolutionDetails,
  ResolutionDetailsContext
} from '@library/types/resolutions/resolutionDetails';
import {
  defaultFormattedResolutionDetails,
  initialNewResolution
} from '@bo-constants/resolutions/resolutionDetailsContexts';
import type { FormattedResolution } from '@library/types/resolutions/resolutionsList';
import { resolutionsData } from '@bo-test/mock/data/resolutions/resolutionsList';
import { useGetResolutionDetailsQuery } from '@bo-services/resolutionsAPI';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useResolutionDetails = () => {
  const { resolutionId } = useParams();
  const isNewResolution = resolutionId?.toUpperCase() === 'NEW';
  const isNumericResolutionId =
    resolutionId && !Number.isNaN(Number(resolutionId));

  const { data } = resolutionsData;

  const resolution: FormattedResolution =
    !isNewResolution && resolutionId
      ? data[resolutionId]
      : initialNewResolution;

  const {
    data: resolutionData,
    isError: resolutionDataFetchError = false,
    isLoading
  } = useGetResolutionDetailsQuery(
    {
      resolutionId: resolutionId || ''
    },
    { skip: isNewResolution || !isNumericResolutionId }
  );

  const resolutionDetails: FormattedResolutionDetails =
    resolutionId && resolutionData
      ? resolutionData
      : defaultFormattedResolutionDetails;

  const resolutionDetailsContext: ResolutionDetailsContext = useMemo(() => {
    return {
      isLoading,
      isNewResolution,
      resolution,
      resolutionDetails,
      resolutionDataFetchError
    };
  }, [
    isLoading,
    isNewResolution,
    resolution,
    resolutionDetails,
    resolutionDataFetchError
  ]);

  return {
    resolutionDetailsContext
  };
};
